export const NEW_PRODUCT_MAX_AGE_DAYS = 90;

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

/** Epoch seconds from a product summary, or a Date/ISO string from a course run. */
export type GoLiveDate = number | Date | string | null | undefined;

const toEpochMilliseconds = (goLiveDate: GoLiveDate): number => {
  if (typeof goLiveDate === "number") {
    return Number.isFinite(goLiveDate) ? goLiveDate * 1000 : Number.NaN;
  }

  if (goLiveDate instanceof Date) {
    return goLiveDate.getTime();
  }

  if (typeof goLiveDate === "string" && goLiveDate !== "") {
    return Date.parse(goLiveDate);
  }

  return Number.NaN;
};

export const isNewProduct = (
  goLiveDate: GoLiveDate,
  nowMs: number = Date.now(),
  maxAgeDays: number = NEW_PRODUCT_MAX_AGE_DAYS,
): boolean => {
  if (
    !Number.isFinite(nowMs) ||
    !Number.isFinite(maxAgeDays) ||
    maxAgeDays < 0
  ) {
    return false;
  }

  const ageMilliseconds = nowMs - toEpochMilliseconds(goLiveDate);

  return (
    Number.isFinite(ageMilliseconds) &&
    ageMilliseconds >= 0 &&
    ageMilliseconds <= maxAgeDays * MILLISECONDS_PER_DAY
  );
};
